export const CB = 'CB';
export const GOOGLE_PAY = 'GOOGLEPAY';
export const APPLE_PAY = 'APPLEPAY';
export const PAYPAL = 'PAYPAL';
export const ENTERPRISE_CARD = 'ENTERPRISE_CARD';



// WEBPACK FOOTER //
// ./src/constants/paymentMethods.js